import { useEffect, useState } from "react";
import LoaderWrapper from "../../../../widgets/loaderWrapper/LoaderWrapper";
import { configureTableLazyState, defineTableColumnsFromArray, defineTableFilters } from "../../../../widgets/table/tableFeatures/tableFunctions";
import TableWidget from "../../../../widgets/table/tableWidget/TableWidget";
import { getValueWithMapLinks, prepareTableData } from "../../../../features/dataFormatFunctions/dataFormatter";
import { useNavigate, useParams } from "react-router-dom";
import { getMapLinkColumn } from "../../../../widgets/table/tableFeatures/tableTemplates/tableColumnTemplates";
import { useFetchRoadDiagnosticsSegmentsQuery, useFetchRoadMeasuresQuery } from "../../../../api/rtk/base/slices/diagnosticsApiSlice";
import TableTitleRow from "../../../../widgets/table/tableAddons/tableTitleRow/TableTitleRow";
import { setCurrentRoadDiagnosticsSegmentNew, showToastMessage } from "../../../../stateManagement/reducers";
import { useDispatch } from "react-redux";
import ToastMessageContainer from "../../../../widgets/toastMessageContainer/ToastMessageContainer";
import { DataTableSelectEvent } from "primereact/datatable";
import { setCurrentRoadMeasure } from "../../../../stateManagement/reducers/diagnostics/RoadMeasuresSlice";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { getDataArrayWithMaintenanceEnding, getDataArrayWithMaintenancePosition } from "../../../../features/dataFormatFunctions/formatMaintenancePoint";

const columnsStructure: any = [
    {
        headerName: "Начало, км",
        field: "SectionStart",
        align: "right",
        valueType: "float"
    },
    {
        headerName: "Начало, км+",
        field: "MaintenancePosition",
        valueType: "int",
        canBeFiltered: false,
        align: "right"
    },
    {
        headerName: "Конец, км",
        field: "SectionEnd",
        valueType: "float",
        filterPlaceholder: "Конец, км  =",
        align: "right"
    },
    {
        headerName: "Конец, км+",
        field: "MaintenanceEnding",
        valueType: "int",
        canBeFiltered: false,
        align: "right"
    },
    {
        headerName: "Вид измерения",
        field: "MeasureTypeString",
        valueType: "string",
        align: "right"
    },
    getMapLinkColumn()
]

const selectableMeasureTypeNames = ['Ровность', 'Прочность', 'Сцепление', 'Колейность', 'Модуль упругости']

export default function TableNestedRoadMeasures() {
    const objectTypeName = "RoadMeasures"
    const { eventId } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [tableState, setTableState] = useState<any>(null)
    const [tableValue, setTableValue] = useState<any>([])
    const [columns, setColumns] = useState<any>([])

    const currentRoadDiagnosticsSegment = useAppSelector(state => state.roadDiagnosticsSegments.currentRoadDiagnosticsSegment)

    const { data: requestedDiagnosticsSegment,
        isFetching: requestedDiagnosticsSegmentIsFetching,
        isError: requestedDiagnosticsSegmentIsError
    } = useFetchRoadDiagnosticsSegmentsQuery({ top: 1, filterString: `EventId eq ${eventId}` }, { skip: currentRoadDiagnosticsSegment })

    useEffect(() => {
        if (requestedDiagnosticsSegment?.value[0]) {
            dispatch(setCurrentRoadDiagnosticsSegmentNew(requestedDiagnosticsSegment?.value[0]))
        }
    }, [requestedDiagnosticsSegment])

    const { data: roadMeasures,
        isError: roadMeasuresAreError,
        isFetching: roadMeasuresAreFetching
    } = useFetchRoadMeasuresQuery({ filterString: `EventId eq ${eventId}` })

    useEffect(() => {
        let columns = defineTableColumnsFromArray(columnsStructure)
        let filters = defineTableFilters(columns)
        setColumns(columns)
        setTableState(configureTableLazyState({ filters }))
    }, [])

    useEffect(() => {
        if (roadMeasures && columns) {
            let value = roadMeasures?.value
            value = getValueWithMapLinks(value, objectTypeName)
            value = prepareTableData(value, columns)
            value = getDataArrayWithMaintenanceEnding(value)
            value = getDataArrayWithMaintenancePosition(value)
            setTableValue(value)
        }
    }, [roadMeasures, columns])

    useEffect(() => {
        if (roadMeasuresAreError) {
            dispatch(showToastMessage({ messageText: "Ошибка загрузки таблицы", messageType: "error", windowType: "roadMeasuresTable" }))
        }
    }, [roadMeasuresAreError])

    const rowIsSelectable = (data: any) => selectableMeasureTypeNames.includes(data.MeasureTypeString)

    const rowClassName = (data: any) => (rowIsSelectable(data) ? '' : 'p-disabled');

    function onRowSelect(event: DataTableSelectEvent) {
        const roadMeasure = event?.data
        const { MeasureId, MeasureTypeId } = roadMeasure ?? {}
        dispatch(setCurrentRoadMeasure(roadMeasure))
        navigate(`/app/diagnostics/diagnosticsSegments/${eventId}/roadMeasures/${MeasureId}/roadMeasureResults/${MeasureTypeId}`)
    }

    return (
        <div className="table-widget-with-toast half-size">
            <TableTitleRow text="Участки измерений" />
            <ToastMessageContainer windowType="roadMeasuresTable" />
            <LoaderWrapper isLoading={roadMeasuresAreFetching} className="table-with-title-row" >
                <TableWidget
                    tableValue={tableValue}
                    tableState={tableState}
                    columns={columns}
                    pageSize={100}
                    withTitleRow
                    onRowSelect={onRowSelect}
                    rowIsSelectable={(event: DataTableSelectEvent) => rowIsSelectable(event.data)}
                    rowClassName={rowClassName}
                />
            </LoaderWrapper>
        </div>
    )
}
